import { API_URL } from 'core/constants'
import httpClient from './httpClient'
import { TradeItemCreationData, TradeCustomCreationResult } from 'core/types'

export type FiltersQueryParams = {
  fromTime?: string
  toTime?: string
  instrumentAliases?: string
  journalIds?: string
}

export const createTrade = async (tradeData: TradeItemCreationData) =>
  httpClient.post<{ result: string }>(API_URL + '/api/dashboard/trades', tradeData)

export const createBatchTrade = async (trades: TradeItemCreationData[]) =>
  httpClient.post<TradeCustomCreationResult[]>(API_URL + '/api/dashboard/trades/batch', trades)

export const deleteTrade = async (tradeId: string) =>
  httpClient.delete(API_URL + `/api/dashboard/trades/${tradeId}`)

export const moveTrade = async (tradeId: string, journalId: string) =>
  httpClient.put<{ result: string }>(API_URL + `/api/dashboard/trades/moveTo/${journalId}`, [
    tradeId,
  ])

export const exportTradesAllAsCSV = async (filtersState: FiltersQueryParams) => {
  const url = new URL(API_URL + '/api/dashboard/trades/csv')
  url.search = new URLSearchParams(filtersState).toString()
  return httpClient.get(url.toString(), { responseType: 'blob' })
}

export const exportTradesAllAsXLSX = async (filtersState: FiltersQueryParams) => {
  const url = new URL(API_URL + '/api/dashboard/trades/excel')
  url.search = new URLSearchParams(filtersState).toString()
  return httpClient.get<Blob>(url.toString(), { responseType: 'blob' })
}
